"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$sentArgs = exports.$interceptor = void 0;
exports.$interceptor = Symbol('$interceptor');
exports.$sentArgs = Symbol('$sentArgs');
